<template>
  <div v-if="selectedAddress" class="additionalContacts">
    <div class="mb-3 mt-2">
      <ToggleSwitch
        v-model="selectedAddress.receives_communication"
        class="mr-2"
        data-cy="additional-communication"
      >
        <template #labelOn>
          <div class="ml-2">
            <div><strong>Receives Additional Communications</strong></div>
            <div>
              <p class="mb-0">
                Additional contacts defined in the list below will receive
                notifications.
              </p>
            </div>
          </div>
        </template>
      </ToggleSwitch>
    </div>
    <div v-if="selectedAddress.receives_communication">
      <div class="font-bold">Email <span class="text-danger">*</span></div>
      <EmailField
        v-if="getEmail('primary')"
        ref="primaryEmailForm"
        :model-value="getEmail('primary')"
        primary
        :validate-global-unique-email="false"
        @update:model-value="setEmail('primary', $event)"
      />
      <div v-if="additionalEmails.length">
        <strong>Additional Email(s)</strong>
      </div>
      <EmailField
        v-for="email in additionalEmails"
        ref="additionalEmailForm"
        :key="`email'-${email.id}`"
        :model-value="getEmail(email.id)"
        :name="`${email.id}-email`"
        :validate-global-unique-email="false"
        @update:model-value="setEmail(email.id, $event)"
        @delete-email="removeEmail(email.id)"
      />
      <ItemAdder
        text="Add Email"
        class="mt-3 mb-3"
        slim
        transparent
        data-cy="add-email"
        @click="addEmail"
      />

      <div class="font-bold">Phone <span class="text-danger">*</span></div>
      <PhoneField
        v-if="getPhone('primary')"
        ref="primaryPhoneForm"
        :model-value="getPhone('primary')"
        primary
        name="primary-phone"
        hide-set-primary
        :can-delete="false"
        @update:model-value="setPhone('primary', $event)"
      />
      <div v-if="additionalPhones.length">
        <strong>Additional Phone(s)</strong>
      </div>
      <PhoneField
        v-for="phone in additionalPhones"
        ref="additionalPhoneForm"
        :key="`phone'-${phone.id}`"
        :model-value="getPhone(phone.id)"
        hide-set-primary
        :name="`${phone.id}-phone`"
        @update:model-value="setPhone(phone.id, $event)"
        @delete-phone="removePhone(phone.id)"
      />
      <ItemAdder
        text="Add Phone"
        class="mt-3 mb-3"
        slim
        transparent
        data-cy="add-phone"
        @click="addPhone"
      />
    </div>
  </div>
</template>

<script>
import ItemAdder from "@/components/ItemAdder.vue";
import ToggleSwitch from "@/components/ToggleSwitch.vue";
import EmailField from "@/Customer/EmailField.vue";
import PhoneField from "@/Customer/PhoneField.vue";
import useVuelidate from "@vuelidate/core";
import { injectUseSelectedAddress } from "./useSelectedAddress";

export default {
  components: {
    ItemAdder,
    ToggleSwitch,
    EmailField,
    PhoneField
  },
  setup() {
    return {
      ...injectUseSelectedAddress(),
      v$: useVuelidate()
    };
  },
  watch: {
    "selectedAddress.receives_communication": {
      immediate: true,
      handler(newValue) {
        if (!newValue) return;
        if (!this.getEmail("primary")) {
          this.addEmail(true);
        }
        if (!this.getPhone("primary")) {
          this.addPhone(true);
        }
      }
    }
  }
};
</script>
